'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _EventUtils = require('../../../utils/EventUtils');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The maximum number of reactions to initially show on a message.
/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var MAX_ITEMS_WHEN_LIMITED = 8;

var ReactionsRow = function (_React$PureComponent) {
    (0, _inherits3.default)(ReactionsRow, _React$PureComponent);

    function ReactionsRow(props) {
        (0, _classCallCheck3.default)(this, ReactionsRow);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReactionsRow.__proto__ || (0, _getPrototypeOf2.default)(ReactionsRow)).call(this, props));

        _this.onReactionsChange = function () {
            // TODO: Call `onHeightChanged` as needed
            _this.setState({
                myReactions: _this.getMyReactions()
            });
            // Using `forceUpdate` for the moment, since we know the overall set of reactions
            // has changed (this is triggered by events for that purpose only) and
            // `PureComponent`s shallow state / props compare would otherwise filter this out.
            _this.forceUpdate();
        };

        _this.onShowAllClick = function () {
            _this.setState({
                showAll: true
            });
        };

        if (props.reactions) {
            props.reactions.on("Relations.add", _this.onReactionsChange);
            props.reactions.on("Relations.remove", _this.onReactionsChange);
            props.reactions.on("Relations.redaction", _this.onReactionsChange);
        }

        _this.state = {
            myReactions: _this.getMyReactions(),
            showAll: false
        };
        return _this;
    }

    (0, _createClass3.default)(ReactionsRow, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.reactions !== this.props.reactions) {
                this.props.reactions.on("Relations.add", this.onReactionsChange);
                this.props.reactions.on("Relations.remove", this.onReactionsChange);
                this.props.reactions.on("Relations.redaction", this.onReactionsChange);
                this.onReactionsChange();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.reactions) {
                this.props.reactions.removeListener("Relations.add", this.onReactionsChange);
                this.props.reactions.removeListener("Relations.remove", this.onReactionsChange);
                this.props.reactions.removeListener("Relations.redaction", this.onReactionsChange);
            }
        }
    }, {
        key: 'getMyReactions',
        value: function getMyReactions() {
            var reactions = this.props.reactions;
            if (!reactions) {
                return null;
            }
            var userId = _MatrixClientPeg2.default.get().getUserId();
            var myReactions = reactions.getAnnotationsBySender()[userId];
            if (!myReactions) {
                return null;
            }
            return [].concat((0, _toConsumableArray3.default)(myReactions.values()));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                mxEvent = _props.mxEvent,
                reactions = _props.reactions;
            var _state = this.state,
                myReactions = _state.myReactions,
                showAll = _state.showAll;


            if (!reactions || !(0, _EventUtils.isContentActionable)(mxEvent)) {
                return null;
            }

            var ReactionsRowButton = _index2.default.getComponent('messages.ReactionsRowButton');
            var items = reactions.getSortedAnnotationsByKey().map(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    content = _ref2[0],
                    events = _ref2[1];

                var count = events.size;
                if (!count) {
                    return null;
                }
                var myReactionEvent = myReactions && myReactions.find(function (mxEvent) {
                    if (mxEvent.isRedacted()) {
                        return false;
                    }
                    return mxEvent.getRelation().key === content;
                });
                return _react2.default.createElement(ReactionsRowButton, {
                    key: content,
                    content: content,
                    count: count,
                    mxEvent: mxEvent,
                    reactionEvents: events,
                    myReactionEvent: myReactionEvent
                });
            }).filter(function (item) {
                return !!item;
            });

            // Show the first MAX_ITEMS if there are MAX_ITEMS + 1 or more items.
            // The "+ 1" ensure that the "show all" reveals something that takes up
            // more space than the button itself.
            var showAllButton = void 0;
            if (items.length > MAX_ITEMS_WHEN_LIMITED + 1 && !showAll) {
                items = items.slice(0, MAX_ITEMS_WHEN_LIMITED);
                showAllButton = _react2.default.createElement(
                    'a',
                    {
                        className: 'mx_ReactionsRow_showAll',
                        href: '#',
                        onClick: this.onShowAllClick
                    },
                    (0, _languageHandler._t)("Show all")
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'mx_ReactionsRow' },
                items,
                showAllButton
            );
        }
    }]);
    return ReactionsRow;
}(_react2.default.PureComponent);

ReactionsRow.propTypes = {
    // The event we're displaying reactions for
    mxEvent: _propTypes2.default.object.isRequired,
    // The Relations model from the JS SDK for reactions to `mxEvent`
    reactions: _propTypes2.default.object
};
exports.default = ReactionsRow;
module.exports = exports['default'];
//# sourceMappingURL=ReactionsRow.js.map